import type { Customer, CustomersListParams, CustomersListResponse, Job, NoteEntry } from '../types';
import { apiClient } from './client';
import type { ListCustomersResult, ListCustomerNotesResult, CustomerNote } from '@jobmate/types'; // #67 shared-types

export const customers = {
  list: async (params?: CustomersListParams): Promise<CustomersListResponse> => {
    // KNOWN DRIFT: Wire Customer uses customer_name/address_* fields; local Customer uses
    // first_name/last_name/site_address_* fields. Cast required until customer types are unified.
    const { data } = await apiClient.get<ListCustomersResult>('/api/customers', { params });
    return data as unknown as CustomersListResponse;
  },

  get: async (id: number): Promise<Customer> => {
    const { data } = await apiClient.get<Customer>(`/api/customers/${id}`);
    return data;
  },

  create: async (payload: Partial<Customer>): Promise<Customer> => {
    const { data } = await apiClient.post<Customer>('/api/customers', payload);
    return data;
  },

  update: async (id: number, payload: Partial<Customer>): Promise<Customer> => {
    const { data } = await apiClient.patch<Customer>(`/api/customers/${id}`, payload);
    return data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/customers/${id}`);
  },

  getJobs: async (id: number, params?: { page?: number }): Promise<{ jobs: Job[]; total: number }> => {
    const { data } = await apiClient.get<{ jobs: Job[]; total: number }>(`/api/customers/${id}/jobs`, { params });
    return data;
  },

  getNotes: async (id: number): Promise<{ notes: NoteEntry[] }> => {
    // KNOWN DRIFT: Wire CustomerNote.created_at is number (ms); NoteEntry.created_at is string.
    // Cast required until note types are unified.
    const { data } = await apiClient.get<ListCustomerNotesResult>(`/api/customers/${id}/notes`);
    return data as unknown as { notes: NoteEntry[] };
  },

  addNote: async (id: number, text: string): Promise<{ note: NoteEntry }> => {
    // KNOWN DRIFT: Wire CustomerNote differs from NoteEntry in timestamp types.
    const { data } = await apiClient.post<CustomerNote>(`/api/customers/${id}/notes`, { text });
    return { note: data as unknown as NoteEntry };
  },
};
